<template>
    <div class="gallery-info">
        <div class="w-100">
            <el-button type="primary" @click="handleSubmit">保存</el-button>
        </div>
        <div class="main-images">
            <div class="section-title">主图</div>
            <upload-img  :form-data="formData" :upload_url="upload_url" :file-list="mainImages" @updatefileList="updatefileList('main', $event)" @delData="handleDelData('main', $event)" @updateFormData="updateFormData" type="main" @dragEnd="handleDragEnd" :selectSkuList="selectSkuList"></upload-img >
        </div>

        <div class="reference-images">
            <div class="section-title">参数图</div>
            <upload-img  :form-data="formData" :upload_url="upload_url" :file-list="referenceImages" @updatefileList="updatefileList('reference', $event)" @delData="handleDelData('reference', $event)" :selectSkuList="selectSkuList"></upload-img >
        </div>

        <div class="scene-images">
            <div class="section-title">场景图</div>
            <upload-img  :form-data="formData" :upload_url="upload_url" :file-list="sceneImages" @updatefileList="updatefileList('scene', $event)" @delData="handleDelData('scene', $event)" :selectSkuList="selectSkuList"></upload-img >
        </div>

        <div class="detail-images">
            <div class="section-title">细节图</div>
            <upload-img  :form-data="formData" :upload_url="upload_url" :file-list="detailImages" @updatefileList="updatefileList('detail', $event)"  @delData="handleDelData('detail', $event)" :selectSkuList="selectSkuList"></upload-img >
        </div>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
import UploadImg from '@/components/uploadImg/index.vue'

export default {
    name: 'GalleryInfo',
    props: {
        formData: {
            type: Object,
            default: () => ({})
        },
        selectSkuList: {
            type: Array,
            default: () => []
        }
    },
    components: {
        UploadImg
    },
    data() {
        return {
            mainImages: [],
            referenceImages: [],
            sceneImages: [],
            detailImages: [],
            upload_url: Baseurl + "xgImage/uploadImage",
            currentFileList: {
                main: [],
                reference: [],
                scene: [],
                detail: []
            },
        }
    },
    watch: {
        formData: {
            handler(newVal) {
                if (newVal) {
                    if (newVal.images && newVal.images.trim() !== '') {
                        newVal.imagesJson = JSON.parse(newVal.images)
                    }
                    this.initImages(newVal)
                }
            },
            immediate: true
        }
    },
    methods: {
        // 清空所有图片数据
        clearAllImages() {
            this.mainImages = [];
            this.referenceImages = [];
            this.sceneImages = [];
            this.detailImages = [];
            this.currentFileList = {
                main: [],
                reference: [],
                scene: [],
                detail: []
            };
            this.updateFormData();
        },
        initImages(data) {
            // 初始化各个类型的图片列表
            if (data.imagesJson) {
                // 处理主图
                if (data.imagesJson.mainImages && Array.isArray(data.imagesJson.mainImages)) {
                    this.mainImages = data.imagesJson.mainImages.map(url => ({
                        url,
                        uid: Date.now() + Math.random().toString(36).substr(2)
                    }));
                }
                // 处理参考图
                if (data.imagesJson.referenceImages && Array.isArray(data.imagesJson.referenceImages)) {
                    this.referenceImages = data.imagesJson.referenceImages.map(url => ({
                        url,
                        uid: Date.now() + Math.random().toString(36).substr(2)
                    }));
                }
                // 处理场景图
                if (data.imagesJson.sceneImages && Array.isArray(data.imagesJson.sceneImages)) {
                    this.sceneImages = data.imagesJson.sceneImages.map(url => ({
                        url,
                        uid: Date.now() + Math.random().toString(36).substr(2)
                    }));
                }
                // 处理细节图
                if (data.imagesJson.detailImages && Array.isArray(data.imagesJson.detailImages)) {
                    this.detailImages = data.imagesJson.detailImages.map(url => ({
                        url,
                        uid: Date.now() + Math.random().toString(36).substr(2)
                    }));
                }
            }
        },
        handlePreview(file) {
            // 处理图片预览
            window.open(file.url)
        },
        handleRemove(file, type) {
            // 处理图片移除
            this[`${type}Images`] = this[`${type}Images`].filter(item => item.uid !== file.uid)
            this.updateFormData()
        },
        handleSuccess(res, file, fileList, type) {
            if (res.code === 200) {
                this.$message.success('上传成功!');
                // 更新对应类型的图片列表
                this[`${type}Images`] = fileList.map(item => ({
                    ...item,
                    url: item.response?.data || item.url || item.imageUrl,
                    uid: item.uid || Date.now() + Math.random().toString(36).substr(2)
                }));
                this.updateFormData();
            } else {
                this.$message.error(res.data || '上传失败!');
            }
        },
        handleChange(file, fileList, type) {
            // 更新当前文件列表
            this.currentFileList[type] = fileList
        },
        updateFormData(e) {
            // 更新父组件数据
            let updatedData = {
                ...this.formData,
                imagesJson: {
                    mainImages: this.mainImages.map(img => img.url),
                    referenceImages: this.referenceImages.map(img => img.url),
                    sceneImages: this.sceneImages.map(img => img.url),
                    detailImages: this.detailImages.map(img => img.url)
                }
            };
            if(e){
                updatedData = e;
            }

            // 只在新建时设置默认主图
            if (this.mainImages.length > 0 && !this.formData.id) {
                updatedData.image = this.mainImages[0].url;
            } else if (this.formData.id && this.mainImages.length > 0) {
                // 编辑下，如果主图被删除，则使用第一张主图
                if(!this.mainImages.includes(this.formData.image)){
                    updatedData.image = this.mainImages[0].url;
                }
            }
            this.$emit('update:formData', updatedData);
        },
        // 更新产品 ID
        updateProductId(id) {
            if (id && this.formData) {
                this.$set(this.formData, 'id', id)
            }
        },
        handleDragEnd(e){
            this.mainImages = e;
            const updatedData = {
                ...this.formData,
                image: e[0].url
            }
            this.$emit('update:formData', updatedData);
        },
        // 保存图库信息
        async handleSubmit() {
            try {
                if (!this.formData.id) {
                    this.$message.warning('请先保存基本信息!')
                    return
                }
                const imagesJson = {
                    mainImages: this.mainImages.map(img => img.url),
                    referenceImages: this.referenceImages.map(img => img.url),
                    sceneImages: this.sceneImages.map(img => img.url),
                    detailImages: this.detailImages.map(img => img.url)
                };
                const response = await ajaxPost(`${Baseurl}productController/updateProductLibrary`, {
                    id: this.formData.id,
                    imagesJson
                })
                if (response.data.code === 200) {
                    // 更新 formData 中的 images 字段
                    this.$set(this.formData, 'images', JSON.stringify(imagesJson));
                    this.$message.success('保存图库成功!')
                } else {
                    this.$message.error(response.msg || '保存图库失败!')
                }
            } catch (error) {
                this.$message.error('保存图库失败，请重试!')
            }
        },
        
        handleDelData(type, data){
            if(type === 'main'){
                this.mainImages = this.mainImages.filter(item => item.uid !== data.data.uid);
                if(this.mainImages.length === 0){
                    this.updateFormData({
                        ...this.formData,
                        image: '',
                    });
                    return
                }
            }else if(type === 'reference'){
                this.referenceImages = this.referenceImages.filter(item => item.uid !== data.data.uid);
            }else if(type === 'scene'){
                this.sceneImages = this.sceneImages.filter(item => item.uid !== data.data.uid);
            }else if(type === 'detail'){
                this.detailImages = this.detailImages.filter(item => item.uid !== data.data.uid);
            }
            this.updateFormData();
        },
        updatefileList(type, e){
            if(type === 'main'){
                this.mainImages = e;
            }else if(type === 'reference'){
                this.referenceImages = e;
            }else if(type === 'scene'){
                this.sceneImages = e;
            }else if(type === 'detail'){
                this.detailImages = e;
            }
            this.updateFormData();
        },
        // 更新主图顺序
        updateMainImageOrder(e) {
            this.mainImages = e.map(url => ({
                url,
                uid: Date.now() + Math.random().toString(36).substr(2)
            }));
            this.updateFormData();
        }
    },
    beforeDestroy() {
        // 组件销毁前清空所有图片数据
        this.clearAllImages();
    }
}
</script>

<style lang="scss" scoped>
.gallery-info {
    padding-bottom: 60px;

    .section-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
        color: #303133;
    }

    .main-images,
    .reference-images,
    .scene-images,
    .detail-images {
        margin-bottom: 30px;
    }

    :deep(.el-upload--picture-card) {
        width: 120px;
        height: 120px;
        line-height: 120px;
        position: relative;
    }

    :deep(.el-upload-list--picture-card .el-upload-list__item) {
        width: 120px;
        height: 120px;
        position: relative;

        .el-progress {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80% !important;
        }
    }

    :deep(.el-upload-list--picture-card) {
        .el-upload-list__item-status-label {
            display: none;
        }

        .el-progress--circle {
            display: inline-flex;
            justify-content: center;
            align-items: center;
        }

        .el-progress-circle {
            width: 60px !important;
            height: 60px !important;
        }
    }
}

.w-100 {
    width: 100%;
    display: flex;
}

:deep(.el-upload-list__item .el-upload-list__item-status-label) {
    display: none;
}

:deep(.el-upload-list__item .el-icon-check) {
    display: none;
}
</style>